// extracted by mini-css-extract-plugin
export default {"container":"RootErrorBoundary_container__HlMrR"};